import LooksSimilarItems from "./LooksSimilarItems";

export default LooksSimilarItems;
